import React from 'react';
import { useParams } from 'react-router-dom';
import { PersonAuthorizationScope } from 'authorization-scope';
import {
  PERSON_UPDATED,
  PersonPermission,
  TeamPermission,
  useTeamMembersService
} from 'nekst-api';
import SinglePersonPage from '../../people/shared/SinglePersonPage';

import Row6x6x from '../../shared/web/uitheme/form/Row6x6x';
import styles from '../../people/Update/PersonUpdatePage.module.scss';
import {
  DeleteTeamMemberButton,
  ResendInvitationButton,
  TeamMemberSenderEmailWidget,
  UpdatePersonForm
} from 'features/tasks-forms';
import AccessChecker from '../../shared/authorization/AccessChecker';
import PersonNotesList from '../../people/Notes/PersonNotesList';
import ManageAssignmentsList from '../../people/Update/ManageAssignmentsList';
import { Separator } from 'features/nekst-widgets';
import { TeamMembersBreadcrumbs } from './TeamMembersBreadcrumbs';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import OpenHistoryPageButton from './history/OpenHistoryPageButton';
import useSettingsNavigator from '../settingsNavigator';
import { Header3, LoadingAnimation } from 'ui-builder';
import { useDataLoaderNew } from 'data-loader';

export default function UpdateTeamMemberPage() {
  const teamMembersService = useTeamMembersService();

  const personId = useParams().id! as unknown as number;

  const settingsNavigator = useSettingsNavigator();

  const { data: person } = useDataLoaderNew(
    async () => teamMembersService.getById(personId),
    {
      events: [PERSON_UPDATED],
    }
  );

  if (person) {
    return (
      <PersonAuthorizationScope id={personId}>
        <>
          <TeamMembersBreadcrumbs>
            <Breadcrumb text={person.profile.name.fullName} />
          </TeamMembersBreadcrumbs>
          <SinglePersonPage
            headerRight={(
              <>
                <OpenHistoryPageButton person={person} />
                <ResendInvitationButton teamMember={person} />
                <DeleteTeamMemberButton
                  teamMemberId={person.id}
                  afterDeleteFunc={() => {
                    settingsNavigator.openMembersManagementPage();
                  }}
                />
              </>
            )}
            person={person}
          >
            <Row6x6x>
              <div className={styles.leftColumn}>
                <UpdatePersonForm person={person} />
              </div>
              <div className={styles.rightColumn}>
                <AccessChecker
                  permissionToCheck={PersonPermission.READ_NOTES}
                  show403Error={false}
                >
                  <PersonNotesList personId={person.id} />
                  <Separator />
                </AccessChecker>
                <ManageAssignmentsList assignments={person._assignments!} />
                <AccessChecker permissionToCheck={TeamPermission.FEATURE_EMAIL_CONFIGURATION}>
                  <Separator marginSize="big" />
                  <Header3>Email Setup</Header3>
                  <TeamMemberSenderEmailWidget personId={person.id} />
                </AccessChecker>
              </div>
            </Row6x6x>
          </SinglePersonPage>
        </>
      </PersonAuthorizationScope>
    );
  } else {
    return (
      <LoadingAnimation />
    )
  }

}
